import { getAccountValidationForBackgroundCheckSchema } from '@/backend/features/background-check/shared/getAccountValidationForBackgroundCheckSchema';
import { BackgroundCheckData } from '../entities';

export function isBackgroundCheckFormComplete(data: BackgroundCheckData) {
    const validationSchema = getAccountValidationForBackgroundCheckSchema();
    const result = validationSchema.safeParse(data);
    return result.success;
}
